import $ from 'jquery';

const defaults = {
  limit: 128,
  headingsSelector: 'h3, h4',
};

export default class GenerateHeadingAnchors {
  constructor(element, options) {
    this.settings = Object.assign(defaults, options);
    this.$element = $(element);
    this.$headings = this.getHeadings();
    this.anchors = [];
    this.iterate();
  }

  getHeadings() {
    return this.$element.find(this.settings.headingsSelector).not('[id]');
  }

  iterate() {
    this.$headings.each((i, heading) => {
      const text = $(heading).text();
      const safeId = this.generateSafeId(text);
      this.anchors.push(safeId);
      $(heading).attr('id', safeId);
    });
  }

  generateSafeId(input) {
    const safe = this.getInitialId(input);
    const duplicated = this.anchors.includes(safe);
    let output = safe;

    if (duplicated) {
      for (let i = 1; i <= 1000; i += 1) {
        const unique = `${safe}-${i}`;
        if (!this.anchors.includes(unique)) {
          output = unique;
          return output;
        }
      }
    }

    return output;
  }

  getInitialId(text) {
    const rex = /[^a-z0-9-]+/g;
    let safe = text.toLowerCase().trim();

    // Limit the possible length of the generated anchor.
    if (safe.length >= this.settings.limit) {
      safe = safe.substr(0, this.settings.limit);
      // Make sure it ends in a whole word.
      safe = safe.substr(0, safe.lastIndexOf(' '));
    }

    return safe.replace(rex, '-');
  }
}



// WEBPACK FOOTER //
// ./GenerateHeadingAnchors.js